<template>
  <transition name="screenslideup">
    <div v-show="true" class="modal-overlay">
      <div class="modal" style="height: 88vh; overflow-y: auto;">
        <table border="0" width="90%">
          <!-- Cancel & Logo -->
          <tr>
            <td>
              <div class="divl" style="height: 6vh">
                <button class="text-only-button cancel" @click="doCancel">Cancel</button>
              </div>
              <div class="wrapper-todiv" style="height: 8vh">
                <img class="tulogo" style="height: 7vh;" alt="ThankU logo" src="../assets/tutxtlogo.png">
              </div>
            </td>
          </tr>

          <!-- Proof of ID Section -->
          <tr>
            <td>
              <div class="lt-blue txtc" style="font-size: 2.2vh; padding-top: 2vh;">
                <b>1. Proof of Identity</b>
              </div>
              <div class="lt-blue notes-text" style="padding: 0.5vh 0;">
                Please upload a clear photo of your passport or driving licence
              </div>
              <div>
                <button class="widebtn" style="width: 100%;" @click="showIdPopup = true" :disabled="idCompleted">
                  Provide proof of identity
                </button>
              </div>
            </td>
          </tr>

          <!-- Provided filename shown below -->
          <tr>
            <td>
              <div v-if="idCompleted" style="margin-top: 1vh; border: 1px solid #999; padding: 1vh; font-size: 1.7vh;">
                <b>Provided:</b> {{ idFrontFileName }}
                <span v-if="selectedIdType === 'DriversLicense' && idBackFileName"> + {{ idBackFileName }}</span>
              </div>
              <div v-else style="height: 4vh"></div>
            </td>
          </tr>

          <!-- Proof of Address Section -->
          <tr>
            <td>
              <div class="lt-blue txtc" style="font-size: 2.2vh; padding-top: 2vh;">
                <b>2. Proof of Address</b>
              </div>
              <div class="lt-blue notes-text" style="padding: 0.5vh 0;">
                Upload a recent utility bill (less than 3 months old)
              </div>
              <div>
                <button class="widebtn" style="width: 100%;" @click="showAddressPopup = true" :disabled="!idCompleted">
                  Provide proof of address
                </button>
              </div>
            </td>
          </tr>

          <!-- Provided address -->
          <tr>
            <td>
              <div v-if="addressFileName" style="margin-top: 1vh; border: 1px solid #999; padding: 1vh; font-size: 1.7vh;">
                <b>Provided:</b> {{ addressFileName }}
              </div>
              <div v-else style="height: 4vh"></div>
            </td>
          </tr>

          <!-- Submit Button -->
          <tr>
            <td style="height: 10vh;">
              <div>
                <button
                  v-if="idCompleted && addressFileName"
                  class="widebtn"
                  style="width: 70%; height: 5vh;"
                  @click="doUploadDocuments"
                  :disabled="isUploading"
                >
                  {{ isUploading ? 'Uploading...' : 'Submit Documents' }}
                </button>
                <div v-else style="height: 5vh"></div>
              </div>
            </td>
          </tr>

          <!-- Notes -->
          <tr>
            <td>
              <div class="lt-blue notes-text" style="padding-top: 1vh;">
                Your documents are securely encrypted and stored. They will only be used for identity verification purposes.
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>

  <!-- ID Modal -->
  <transition name="fade">
    <div v-show="showIdPopup" class="modal-overlayfrombottomblur" style="z-index: 999;">
      <div class="modal" style="padding: 2vh; width: 80%">
        <table border="0" width="100%">
          <tr>
            <td>
              <label class="lt-blue notes-text">Select ID Type:</label>
              <select v-model="selectedIdType" style="width: 100%; padding: 0.5vh;">
                <option disabled value="">Please choose</option>
                <option value="Passport">Passport</option>
                <option value="DriversLicense">Driving Licence</option>
              </select>
            </td>
          </tr>

          <!-- Passport Flow -->
          <tr v-if="selectedIdType === 'Passport'">
            <td>
              <div class="lt-blue notes-text" style="padding-top: 1vh;">Upload photo of your passport</div>
              <input ref="idFrontFileInput" type="file" accept="image/*,.pdf" @change="handleIdFrontUpload" style="display:none" />
              <button class="widebtn" style="width: 100%; margin-top: 1vh;" @click="$refs.idFrontFileInput.click()">
                Choose image / Take Photo
              </button>
              <div style="height: 3vh; font-size: 1.7vh; padding-top: 0.5vh">
                <div v-if="idFrontFileName">✓ <b>Provided:</b> {{ idFrontFileName }}</div>
              </div>
            </td>
          </tr>

          <!-- Driving Licence Flow -->
          <tr v-if="selectedIdType === 'DriversLicense'">
            <td>
              <div class="lt-blue notes-text" style="padding-top: 1vh;">Front of Driving Licence</div>
              <input ref="idFrontFileInput" type="file" accept="image/*,.pdf" @change="handleIdFrontUpload" style="display:none" />
              <button class="widebtn" style="width: 100%; margin-top: 1vh;" @click="$refs.idFrontFileInput.click()">
                Choose image / Take Photo
              </button>
              <div style="height: 3vh; font-size: 1.7vh; padding-top: 0.5vh">
                <div v-if="idFrontFileName">✓ <b>Provided:</b> {{ idFrontFileName }}</div>
              </div>

              <div class="lt-blue notes-text" style="padding-top: 2vh;">Back of Driving Licence</div>
              <input ref="idBackFileInput" type="file" accept="image/*,.pdf" @change="handleIdBackUpload" style="display:none" />
              <button class="widebtn" style="width: 100%; margin-top: 1vh;" @click="$refs.idBackFileInput.click()">
                Choose image / Take Photo
              </button>
              <div style="height: 3vh; font-size: 1.7vh; padding-top: 0.5vh">
                <div v-if="idBackFileName">✓ <b>Provided:</b> {{ idBackFileName }}</div>
              </div>
            </td>
          </tr>

          <!-- Done -->
          <tr>
            <td style="padding-top: 2vh">
              <button class="widebtn" style="width: 70%" @click="closeIdPopup">Done</button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>

  <!-- Address Modal -->
  <transition name="fade">
    <div v-show="showAddressPopup" class="modal-overlayfrombottomblur" style="z-index: 999;">
      <div class="modal" style="padding: 2vh; width: 80%">
        <table border="0" width="100%">
          <tr>
            <td>
              <div class="lt-blue notes-text">Upload a recent utility bill (less than 3 months old)</div>
              <input ref="addressFileInput" type="file" accept="image/*,.pdf" @change="handleAddressUpload" style="display:none" />
              <button class="widebtn" style="width: 100%; margin-top: 1vh;" @click="$refs.addressFileInput.click()">
                Choose image / Take Photo
              </button>
              <div style="height: 3vh; font-size: 1.7vh; padding-top: 0.5vh">
                <div v-if="addressFileName">✓ <b>Provided:</b> {{ addressFileName }}</div>
              </div>
            </td>
          </tr>

          <tr>
            <td style="padding-top: 2vh">
              <button class="widebtn" style="width: 70%" @click="showAddressPopup = false">Done</button>
            </td>
          </tr>

        </table>
      </div>
    </div>
  </transition>
</template>

<script>
import shared from '../shared.js';

export default {
  name: 'DocumentUploadScreen',
  props: {
    userData: shared.userDataStruct(),
  },
  data() {
    return {
      selectedIdType: '',
      idFrontFile: null,
      idFrontFileName: '',
      idBackFile: null,
      idBackFileName: '',
      addressFile: null,
      addressFileName: '',
      isUploading: false,
      showIdPopup: false,
      showAddressPopup: false,
    };
  },
  computed: {
    idCompleted() {
      return this.selectedIdType === 'Passport'
        ? !!this.idFrontFile
        : this.idFrontFile && this.idBackFile;
    }
  },
  methods: {

    /* Return synchronously like AccountEditScreen */
    doCancel() {
      this.$emit('next-action', {
        nextScreen: 'showPersonalDetails',
        userData: this.userData
      });
    },

    handleIdFrontUpload(event) {
      const f = event.target.files[0];
      if (f && this.validateFile(f)) {
        this.idFrontFile = f;
        this.idFrontFileName = f.name;
      }
    },
    handleIdBackUpload(event) {
      const f = event.target.files[0];
      if (f && this.validateFile(f)) {
        this.idBackFile = f;
        this.idBackFileName = f.name;
      }
    },
    handleAddressUpload(event) {
      const f = event.target.files[0];
      if (f && this.validateFile(f)) {
        this.addressFile = f;
        this.addressFileName = f.name;
      }
    },
    closeIdPopup() {
      if (this.idCompleted) this.showIdPopup = false;
    },

    validateFile(file) {
      const max = 10 * 1024 * 1024;
      const types = ['image/jpeg','image/jpg','image/png','application/pdf'];
      if (!file || file.size > max) return false;
      if (!types.includes(file.type)) return false;
      return true;
    },

    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(r.result.split(',')[1]);
        r.onerror = reject;
        r.readAsDataURL(file);
      });
    },

    async doUploadDocuments() {
      if (!this.idCompleted || !this.addressFile) return;
      try {
        this.isUploading = true;
        const Parse = require('parse/node');

        const proofFront = await this.convertFileToBase64(this.idFrontFile);
        const proofAddress = await this.convertFileToBase64(this.addressFile);
        const proofBack = this.idBackFile ? await this.convertFileToBase64(this.idBackFile) : null;

        const params = {
          userObjectId: window.localStorage.getItem("tuob"),
          proofOfIdDocumentType: this.selectedIdType,
          proofOfIdData: proofFront,
          proofOfIdFileName: this.idFrontFile.name,
          proofOfIdFileType: this.idFrontFile.type,
          proofOfIdBackData: proofBack,
          proofOfIdBackFileName: this.idBackFile ? this.idBackFile.name : "",
          proofOfIdBackFileType: this.idBackFile ? this.idBackFile.type : "",
          proofOfAddressData: proofAddress,
          proofOfAddressFileName: this.addressFile.name,
          proofOfAddressFileType: this.addressFile.type
        };

        await Parse.Cloud.run("uploadVerificationDocuments", params);

        // update userData BEFORE leaving:
        this.userData.documentsUploaded = true;
        this.userData.nextScreen = "showAccountScreen";

        this.isUploading = false;

        // show popup then leave synchronously
        this.$emit("show-popup", {
          title: "Documents Uploaded",
          body: "Your documents have been successfully uploaded for verification."
        });

        // 🔥 **sync emit immediately — no callback**  
        this.$emit("next-action", this.userData);

      } catch (e) {
        this.isUploading = false;
        this.$emit("show-popup", {
          title: "Upload Failed",
          body: "Failed to upload documents: " + (e.message || e)
        });
      }
    }
  },

  mounted() {
    console.log("this.userData on Document upload:", JSON.stringify(this.userData, null, 4));
  }
};
</script>
